<template>
    <v-card flat outlined style="overflow: hidden">
        <v-text-field
            v-model="form.term"
            v-bind="{
                ...attrs_input__verticalTable,
                placeholder: '파일명',
            }"
            @input="emit"
        >
            <template #prepend-inner>
                <v-checkbox v-model="form.isRequired" color="primary" hide-details title="필수여부" @change="emit" />
            </template>
            <template #append>
                <v-icon size="20" color="black" @click="pull"> mdi-minus </v-icon>
            </template>
        </v-text-field>
    </v-card>
</template>

<script>
import { attrs_input__verticalTable, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },
    },
    data: () => ({
        form: initEmploymentField(),
        attrs_input__verticalTable,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        pull() {
            this.$emit("pull", this.form);
        },
    },
};
</script>

<style></style>
